import { styled } from '@comet/styled';

export const ScrollDiv = styled.div`
  max-height: 60vh;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 0px;
  }
`;
